import { Slider as SliderPrimitive } from '@base-ui/react/slider'
import { cn } from '@/lib/utils'

type SliderProps = SliderPrimitive.Root.Props & {
    thumbLabels?: string[]
    formatValueText?: (value: number) => string
}

function Slider({
    className,
    defaultValue,
    value,
    min = 0,
    max = 100,
    thumbLabels,
    formatValueText,
    ...props
}: SliderProps) {
    const values = Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
            ? defaultValue
            : [typeof value === 'number' ? value : min]

    return (
        <SliderPrimitive.Root
            className={cn('data-horizontal:w-full data-vertical:h-full', className)}
            data-slot='slider'
            defaultValue={defaultValue}
            value={value}
            min={min}
            max={max}
            thumbAlignment='edge'
            {...props}
        >
            <SliderPrimitive.Control className='relative flex w-full touch-none items-center py-3 select-none data-disabled:opacity-50'>
                <SliderPrimitive.Track
                    data-slot='slider-track'
                    className='relative h-0.5 w-full grow rounded-full bg-border select-none'
                >
                    <SliderPrimitive.Indicator
                        data-slot='slider-range'
                        className='h-full rounded-full bg-foreground select-none'
                    />
                </SliderPrimitive.Track>

                {values.map((_, index) => (
                    <SliderPrimitive.Thumb
                        data-slot='slider-thumb'
                        key={index}
                        index={index}
                        getAriaLabel={thumbLabels ? () => thumbLabels[index] ?? '' : undefined}
                        getAriaValueText={formatValueText ? (_formatted, thumbValue) => formatValueText(thumbValue) : undefined}
                        className='relative block size-7 shrink-0 rounded-full border border-border bg-white shadow-md transition-[box-shadow,transform] select-none after:absolute after:-inset-2 hover:scale-105 focus-visible:ring-4 focus-visible:ring-ring/40 focus-visible:outline-hidden active:scale-110 has-[:focus-visible]:ring-4 has-[:focus-visible]:ring-ring/40'
                    />
                ))}
            </SliderPrimitive.Control>
        </SliderPrimitive.Root>
    )
}

export { Slider }
